import { useEffect, useState } from 'react';

import { AxiosError } from 'axios';

import { useCwaAxios } from './cwaAxios';
import { TranslationResult, TranslationResults } from '../types';

const useTranslationsData = (
  groupId?: string,
  articleId?: string,
): TranslationResults => {
  const cwaAxios = useCwaAxios();

  const [translations, setTranslations] = useState([] as TranslationResults);
  useEffect(() => {
    const fetchTranslations = async (): Promise<void> => {
      if (!groupId) {
        setTranslations([]);
        return;
      }

      try {
        const translationsResp = await cwaAxios.get(
          `/api/content/translations-search/${groupId}`,
        );
        const processedTranslations = translationsResp.data.results.map(
          (translation: TranslationResult) => ({
            ...translation,
            is_current: translation?.id === articleId,
          }),
        );
        setTranslations(processedTranslations);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(
          'Error fetching translations for in-page nav:',
          (error as AxiosError).response?.data,
        );
        setTranslations([]);
      }
    };

    fetchTranslations();
  }, [groupId, cwaAxios, articleId]);

  return translations;
};

export default useTranslationsData;
